const getEstimatedWait = async (businessUid) => {
  let estimatedWait = 0;
  return estimatedWait;
};

export default getEstimatedWait;
